<template>
  <div class="mb-5">
    <div v-for="(item, index) in devaluations" class="b-contracts__component-item" :key="index">
      <DevaluationsItemWithoutStore
        :isPopup=true
        :devaluationsItem="item"
        :devaluationsItemIndex="index"
        :devaluationsLength="devaluations.length"
        :assetComponent="assetComponent"
        @onDeleteDevaluation="onDeleteDevaluation"
      ></DevaluationsItemWithoutStore>
    </div>
    <div class="row mt-4">
      <div class="col-4">
        <div class="b-form__container">
          <button
            type="button"
            class="b-btn"
            @click="addDevaluations"
            :disabled="isDisabledAddDevaluations"
          >
            <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
            {{$t('CONTENT.assets.add_devaluation')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DevaluationsItemWithoutStore from "../../../assetComponent/components/DevaluationsItemWithoutStore";
import SetDevaluations from "../../models/commands/SetDevaluations";
import { mapGetters } from "vuex";

export default {
  components: {
    DevaluationsItemWithoutStore,
  },
  props: {
    assetComponent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      devaluations: []
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters(["getContractSettings"]),
    isDisabledAddDevaluations() {
      for (let i = 0; i < this.assetComponent.devaluations.length; i++) {
        if (
          this.assetComponent.devaluations[i].startDate === null ||
          this.assetComponent.devaluations[i].sum === null
        ) {
          return true;
        }
      }

      return false;
    },
    currencyCode() {
      return this.getContractSettings.currencyCode;
    },
  },
  methods: {
    init() {
      if(this.assetComponent.devaluations.length !== 0) {
        this.devaluations = _.cloneDeep(this.assetComponent.devaluations);
      } else {
        this.addDevaluations();
      }
    },

    addDevaluations() {
      let item = {
        id: null,
        sum: null,
        startDate: null
      };

      this.devaluations.push(item);
    },

    onDeleteDevaluation(itemIndex) {
      this.devaluations.splice(itemIndex, 1);
    },

    cancel() {
      this.devaluations = [];
    },

    save() {
      const command = new SetDevaluations(
        this.assetComponent.idInDB,
        this.devaluations,
        this.currencyCode
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>
